import { AccountContract } from './contracts/AccountContract.js';

const DEFAULT_ACCOUNT_PATH = '/core/account';

export class AccountService extends AccountContract {

    constructor(options = {}) {
        super();

        const {
            httpClient,
            accountPath = DEFAULT_ACCOUNT_PATH,
        } = options;

        if (!httpClient) throw new Error('AccountService: "httpClient" is required.');

        this.http = httpClient;
        this.accountPath = normalizeAccountPath(accountPath);
    }

    async registerUser(data) {
        const response = await this.http.post(`${this.accountPath}/register`, data || {}, {
            contentType: 'json',
            responseType: 'json',
            skipAuthRefresh: true,
            auth: { type: 'cookie' },
        });
        return response?.payload ?? null;
    }

    async verifyEmail(data) {
        const response = await this.http.get(`${this.accountPath}/verify-email`, data || null, {
            responseType: 'json',
            skipAuthRefresh: true,
            auth: { type: 'cookie' },
        });
        return response?.payload ?? null;
    }

    async getDetails() {
        const response = await this.http.get(`${this.accountPath}`, null, {
            responseType: 'json',
            auth: { type: 'cookie' },
        });
        return response?.payload ?? null;
    }

    async changeDetails(data) {
        const response = await this.http.post(`${this.accountPath}`, data || {}, {
            contentType: 'json',
            responseType: 'json',
            auth: { type: 'cookie' },
        });
        return response?.payload ?? null;
    }

    async changePassword(data) {
        const response = await this.http.post(`${this.accountPath}/change-password`, data || {}, {
            contentType: 'json',
            responseType: 'json',
            auth: { type: 'cookie' },
        });
        return response?.payload ?? null;
    }

    async startPasswordReset(data) {
        const response = await this.http.post(`${this.accountPath}/initialize-password-reset`, data || {}, {
            contentType: 'json',
            responseType: 'json',
            skipAuthRefresh: true,
            auth: { type: 'cookie' },
        });
        return response?.payload ?? null;
    }

    async resetPassword(data) {
        const response = await this.http.post(`${this.accountPath}/reset-password`, data || {}, {
            contentType: 'json',
            responseType: 'json',
            skipAuthRefresh: true,
            auth: { type: 'cookie' },
        });
        return response?.payload ?? null;
    }

}

function normalizeAccountPath(path) {
    const normalizedPath = String(path || DEFAULT_ACCOUNT_PATH).replace(/\/+$/g, '');
    return normalizedPath || DEFAULT_ACCOUNT_PATH;
}
